import React from "react";
import { chassis } from "./chassis";
import { useUiLang } from "../../../../stores/uiLang";
import { peT, type PeLessonStrings } from "../../../../i18n/peLesson";

/** Shown when an LTI launch reaches a serving screen without chapter context. */
const MissingChapter: React.FC<{
  screen: keyof PeLessonStrings["missingTitle"];
  /** Launch / lesson language; defaults to the shared UI language (Run E2 J5). */
  lang?: string;
}> = ({ screen, lang }) => {
  const uiLang = useUiLang();
  const t = peT(lang ?? uiLang);
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: chassis.background }}>
      <div className="text-center max-w-md px-6">
        <h1 className="text-xl font-bold mb-2" style={{ color: chassis.textPrimary }}>
          {t.missingTitle[screen]}
        </h1>
        <p style={{ color: chassis.textSecondary }}>
          {t.missingLead} <code>chapter_id</code>, <code>tier</code>, {t.missingAnd}{" "}
          <code>lang</code>.
        </p>
      </div>
    </div>
  );
};

export default MissingChapter;
